import type { ItemResearchEvidence } from "./types";

/** Reject known collection/search destinations; a product URL still needs a source assessment. */
export function isResearchItemURL(value?: string) {
  if (!value) return false;
  try {
    const url = new URL(value);
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return false;
    const path = url.pathname.replace(/\/+$/, "");
    if (!path || /\/(?:search|s|sch|browse)(?:\/|$)/i.test(path)) return false;
    if (/\/(?:collections?|categor(?:y|ies)|brands?|shop-by-brand)(?:\/|$)/i.test(path) && !/\/products?\/[^/]+/i.test(path)) return false;
    return !/\/(?:products|shop|outlet)$|\.sub$/i.test(path);
  } catch { return false; }
}

export function verifiedResearchPrice(entry: ItemResearchEvidence) {
  const check = entry.priceVerification;
  return Boolean(entry.price && check?.verdict === "supported" && check.pageType === "item" && check.itemMatch === "same"
    && isResearchItemURL(entry.sourceURL) && check.sourceURL === entry.sourceURL
    && check.observedPrice?.currency === entry.price.currency && check.observedPrice.amountMinor === entry.price.amountMinor);
}

export function usableResearchPrice(entry: ItemResearchEvidence) {
  if (!verifiedResearchPrice(entry)) return false;
  return entry.type === "active_listing" ? entry.priceVerification?.listingStatus === "active"
    : entry.type === "sold_comparable" && entry.priceVerification?.listingStatus === "sold" && entry.priceVerification.saleConfirmed;
}

export function researchPriceLimitation(entry: ItemResearchEvidence) {
  const check = entry.priceVerification;
  if (!isResearchItemURL(entry.sourceURL) || check?.pageType === "collection" || check?.pageType === "search") return "Product page not found";
  if (check?.itemMatch === "different") return "Different item";
  if (check?.itemMatch === "variant") return "Different size or variant";
  if (check?.listingStatus === "ended") return "Listing ended · sale price not confirmed";
  if (check?.listingStatus === "out_of_stock") return "Out of stock · sale price not confirmed";
  if (check?.observedPrice && entry.price && (check.observedPrice.currency !== entry.price.currency || check.observedPrice.amountMinor !== entry.price.amountMinor)) return "Quoted price differs from the page";
  if (check?.pageType === "unavailable") return "Source unavailable";
  if (entry.type === "sold_comparable" && !check?.saleConfirmed) return "Sale price not confirmed";
  return "Item and price not confirmed";
}
